import React from 'react';

const ProfilePage = () => {
  return (
      <h1>My Profile</h1>
  );
};

export default ProfilePage;